export const GET_TRAININGS = gql`
  query getTrainings {
    trainings {
      items {
        trainingId
        name
        providerId
        description
        duration
        provider
        createdAt
        updatedAt
        trainingType
        language
      }
      totalCount
    }
  }
`

export const GET_COURSES = gql`
  query getCourses {
    courses {
      items {
        courseId
        name
        duration
        description
        providerId
        provider
        createdAt
        updatedAt
        trainings {
          courseId
          training {
            name
            duration
          }
          trainingId
        }
        company {
          companyId
        }
      }
      totalCount
    }
  }
`

export const GET_TRAINING = gql`
  query getTraining($trainingId: String!) {
    training(trainingId: $trainingId) {
      trainingId
      name
      duration
      provider
      createdAt
      updatedAt
    }
  }
`

export const GET_APPLICANT_TRAININGS = gql`
  query getApplicantTrainings($applicantId: String!) {
    applicantTrainings(applicantId: $applicantId) {
      items {
        applicantTrainingId
        trainingId
        training {
          trainingId
          name
          duration
          provider
          createdAt
          updatedAt
        }
        applicantId
        applicant {
          applicantId
          firstName
          lastName
          email
          phone
          createdAt
          updatedAt
        }
        applicantCourses {
          applicantCourseId
          applicantTrainingId
          applicantCourse {
            course {
              name
            }
          }
        }
        employee {
          employeeId
          firstName
          lastName
        }
        status
        startDate
        endDate
        deadline
        createdAt
        updatedAt
      }
      courses {
        applicantCourseId
        applicantId
        courseId
        course {
          courseId
          name
          duration
          provider
          providerId
        }
        employee {
          employeeId
          firstName
          lastName
        }
        documents {
          documentId
          fileName
        }
        status
        startDate
        endDate
        deadline
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`

export const ASSIGN_TRAINING = gql`
  mutation assignTraining($applicantId: String!, $trainingId: String!) {
    assignTraining(applicantId: $applicantId, trainingId: $trainingId) {
      applicantCourse {
        applicantCourseId
      }
      applicantTraining {
        applicantTrainingId
      }
    }
  }
`

export const ASSIGN_TRAININGS = gql`
  mutation assignTrainings(
    $applicantId: String!
    $trainingIds: [String]
    $courseIds: [String]
    $deadline: DateTime
  ) {
    assignTrainings(
      applicantId: $applicantId
      trainingIds: $trainingIds
      courseIds: $courseIds
      deadline: $deadline
    ) {
      applicantTrainingsIds
      applicantCoursesIds
      errors {
        trainingId
        courseId
        errorMsg
      }
    }
  }
`

export const REMOVE_LUMA_APPLICANT_COURSE = gql`
  mutation removeLumaApplicantCourse($applicantCourseId: String!) {
    removeLumaApplicantCourse(applicantCourseId: $applicantCourseId) {
      success
      message
    }
  }
`

export const GET_TRAINING_AUDIT_TRAIL_LOGS = gql`
  query getTrainingAuditTrailLogs(
    $applicantId: String
    $applicantTrainingId: String
    $pageInfo: PageInfoInput
  ) {
    getTrainingAuditTrailLogs(
      applicantId: $applicantId
      applicantTrainingId: $applicantTrainingId
      pageInfo: $pageInfo
    ) {
      items {
        auditTrailId
        type
        title
        message
        createdAt
        updatedAt
        employeeId
        employee {
          employeeId
          firstName
          lastName
          email
          phone
          createdAt
          updatedAt
        }
        applicantTrainingId
        applicantTraining {
          applicantTrainingId
          trainingId
          training {
            trainingId
            name
            duration
            provider
            createdAt
            updatedAt
          }
          applicantId
          applicant {
            applicantId
            firstName
            lastName
            email
            phone
            createdAt
            updatedAt
          }
          status
          startDate
          endDate
          deadline
          createdAt
          updatedAt
        }
      }
      totalCount
    }
  }
`

export const REFRESH_TRAININGS = gql`
  mutation refreshTrainings($guardEmptyCatalog: Boolean) {
    refreshTrainings(guardEmptyCatalog: $guardEmptyCatalog) {
      createdCourses
      createdTrainings
    }
  }
`

export const BULK_ASSIGN_TRAININGS = gql`
  mutation bulkAssignTrainings(
    $applicantIds: [String!]!
    $trainingIds: [String]
    $courseIds: [String]
    $deadline: DateTime
  ) {
    bulkAssignTrainings(
      applicantIds: $applicantIds
      trainingIds: $trainingIds
      courseIds: $courseIds
      deadline: $deadline
    ) {
      applicants {
        applicantId
        success
        errorMsg
        successMsg
      }
    }
  }
`
